<template>
  <div id="dialogflow-container">
    <!-- Dialogflow виджет будет добавлен через скрипт -->
  </div>
</template>

<script>
import "@/plugins/nativescript-webview-interface.js";
export default {
  name: "DialogFlowCX",
  mounted() {
    this.loadDialogflowWidget();
  },
  methods: {
    loadDialogflowWidget() {
      const scriptUrl =
          "https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js";

      if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
        console.log("Script not found, adding it...");
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.crossOrigin = "anonymous";
        script.onload = () => {
          this.initializeDialogflow();
        };
        script.onerror = (error) =>
            console.error("Ошибка при загрузке скрипта", error);
        document.body.appendChild(script);
      } else {
        this.initializeDialogflow();
      }
    },
    initializeDialogflow() {
      const container = document.getElementById("dialogflow-container");

      // Флаг для отслеживания установки обработчика
      if (!window._dfClickHandlerInstalled) {
        window._dfClickHandlerInstalled = true;

        // Устанавливаем обработчик один раз на уровне документа
        document.addEventListener(
            "click",
            function (event) {

              const path = event.composedPath();

              // Ищем сообщение бота в пути
              const botMessage = path.find(element =>
                  element.classList && element.classList.contains('bot-message')
              );

              // Если нашли сообщение бота, ищем в нём ссылку
              if (botMessage) {
                // Проверяем путь клика на наличие ссылки
                let clickedLink = null;
                for (const element of path) {
                  if (element instanceof HTMLAnchorElement) {
                    clickedLink = element;
                    break;
                  }
                }

                // Если нашли ссылку в пути клика
                if (clickedLink) {
                  console.log("URL:", clickedLink.href);

                  event.preventDefault();
                  event.stopPropagation();

                  const url = clickedLink.href;
                  let oWebViewInterface = window.nsWebViewInterface;
                  oWebViewInterface.emit("url", url);
                }
              }
            },
            true
        );
      }

      const dfMessenger = document.createElement("df-messenger");
      dfMessenger.setAttribute("project-id", "energy-458914");
      dfMessenger.setAttribute("agent-id", "3b7460bc-730d-419e-8062-03b4c526bf80");
      dfMessenger.setAttribute("language-code", "uk");
      dfMessenger.setAttribute("max-query-length", "-1");

      const chatBubble = document.createElement("df-messenger-chat-bubble");
      chatBubble.setAttribute("chat-title", "Чат");
      chatBubble.setAttribute("placeholder-text", "Пишіть сюди…");
      dfMessenger.appendChild(chatBubble);

      const style = document.createElement("style");
      style.textContent = `
    df-messenger {
      z-index: 999;
      position: fixed;
      --df-messenger-font-color: #000;
      --df-messenger-font-family: Google Sans;
      --df-messenger-chat-background: #f3f6fc;
      --df-messenger-message-user-background: #d3e3fd;
      --df-messenger-message-bot-background: #fff;
      bottom: 16px;
      right: 16px;
    }
  `;
      dfMessenger.appendChild(style);
      container.appendChild(dfMessenger);

      // Проверяем наличие shadowRoot
      const tryAttachClickHandler = () => {
        const shadowRoot = dfMessenger.shadowRoot;
        if (shadowRoot) {
          console.log("ShadowRoot найден!");
        } else {
          console.log("shadowRoot еще не готов, пробуем позже...");
          setTimeout(tryAttachClickHandler, 500);
        }
      };

      tryAttachClickHandler();
    },
  },
};
</script>

<style scoped>
#dialogflow-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
}
</style>
